import { ChatPromptEditorPage } from './ChatPromptEditorPage';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  user_id: z.string().optional(),
});

export const Route = createFileRoute('/_protected/admin/internal-tools/chat-prompt-editor/')({
  component: ChatPromptEditorPage,
  validateSearch: searchSchema,
});
